import { render, staticRenderFns } from "./QuickStart.vue?vue&type=template&id=180d27ec"
import script from "./QuickStart.vue?vue&type=script&lang=js"
export * from "./QuickStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports